module.exports = "/_next/static/images/petal-1e8c07921af31180b7ffa1dfff6514c6.jpg";